export default __webpack_public_path__ + "files/99ec979441ce5d5c1e4d61f0af5aa30b.mp3";